import React from 'react';
import { Button } from '@/components/ui/button';

type State = {
  hasError: boolean;
};

class AppRouteErrorBoundary extends React.Component<React.PropsWithChildren, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: unknown) {
    console.error('Route rendering error:', error);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[50vh] flex items-center justify-center px-4 py-12">
          <div className="max-w-md text-center space-y-4">
            <h1 className="public-card-title">Page failed to load</h1>
            <p className="public-small">
              The app refreshed assets during navigation. Reload once to get the latest page bundle.
            </p>
            <Button onClick={this.handleReload}>Reload page</Button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default AppRouteErrorBoundary;
